import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Button } from '../../../../../iba-components/Button'
import { Select } from '../../../../../iba-components/Select'
import './clientInfoManagement.css'
import SignUpClientModal from '../../../../components/SignUpClientModal/signUpClient'
import LoadingMask from '../../../../components/LoadingMask'
import ConfirmModal from '../../../../components/ConfirmModal'

import { getALLClientList } from '../../../../api/client_managementV2'
import styles from './clientInfoManagement.module.css'

const ClientInfoManagement = ({
    id,
    updateClient,
    fetchClientInfo,
    clientInfo,
    clientInfoLoading,
    terminateClient
}) => {
    const { t } = useTranslation()
    const [allClientsList, setAllClientsList] = useState([])
    const [updatVisibleModal, setUpdateVisibleModal] = useState(false)
    const [isReloadClient, setIsReloadClient] = useState(false)
    // confirm ternimation
    const [selectValue, setSelectValue] = useState('')
    const [clientIdToConfirm, setClientIdToConfirm] = useState()
    const [showTerminationModal, setShowTerminationModal] = useState(false)
    const [showMissmatchError, setShowMissmatchError] = useState(false)

    const handleChangeSelect = (value, content) => {
        setSelectValue(content)
        setShowMissmatchError(false)
        setClientIdToConfirm(value)
    }

    useEffect(() => {
        fetchClientInfo()
    }, [isReloadClient, fetchClientInfo])

    useEffect(() => {
        getALLClientList().then(({ clientList }) => {
            const selectClientList = clientList?.map((client) => {
                return {
                    value: client.id,
                    content: `${client.companyname} - ${client.industries}`
                }
            })
            setAllClientsList(selectClientList)
        })
    }, [])

    const handleCancelSignUpModal = (e, company_name) => {
        setUpdateVisibleModal(false)

        if (e === 'reloadClient') {
            setIsReloadClient(!isReloadClient)
            updateClient(company_name)
        }
    }

    // 解約
    const terminateClientSubmit = () => {
        if (clientIdToConfirm && clientIdToConfirm === id) {
            setShowTerminationModal(false)
            setSelectValue('')
            setClientIdToConfirm()
            terminateClient()
        } else {
            setShowMissmatchError(true)
        }
    }

    return (
        <div className="client-info-management-container">
            <div className="client-info-container">
                <div className="title-container d-flex justify-content-between align-items-center">
                    <Button
                        width="64px"
                        label={t('clientManagement.update')}
                        onClick={() => setUpdateVisibleModal(true)}
                    />
                </div>
                <div className="row company-info-container">
                    <div className="col-4">
                        <div className="label">{t('signUpClient.companyName')}:</div>
                        <div className="content">{clientInfo.companyname}</div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.contractName1')}:</div>
                        <div className="content">{clientInfo.contractrepresentativename1}</div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.industries')}:</div>
                        <div className="content">{clientInfo.industriesname}</div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.postalCode')}:</div>
                        <div className="content">{clientInfo.postalcode}</div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.companyAddress')}:</div>
                        <div className="content">{clientInfo.companyaddress}</div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.phoneNumber')}:</div>
                        <div className="content">{clientInfo.phonenumber}</div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.contractEmail1')}:</div>
                        <div className="content">{clientInfo.contractrepresentativeemail1}</div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.contractPlan')}:</div>
                        <div className="content">
                            {clientInfo.contractplan === '0'
                                ? t(`signUpClient.contractPlanList.basic`)
                                : clientInfo.contractplan === '1'
                                ? t(`signUpClient.contractPlanList.advanced`)
                                : clientInfo.contractplan === '2'
                                ? t(`signUpClient.contractPlanList.managed`)
                                : 'Invalid contract'}
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="label">{t('signUpClient.clientTheme')}:</div>
                        <div className="content">{clientInfo.thememapname}</div>
                    </div>
                    <div className="col-4">
                        <div className="label">{t('signUpClient.trial')}:</div>
                        <div className="content">{clientInfo.is_trial ? t('clientManagement.trialStatus') : <></>}</div>
                    </div>
                </div>
                <div className="button-line">
                    <Button
                        width="96px"
                        label={
                            !clientInfo.terminated
                                ? t('clientManagement.termination')
                                : t('clientManagement.stopTermination')
                        }
                        onClick={() => setShowTerminationModal(true)}
                    />
                </div>
            </div>

            {updatVisibleModal && (
                <SignUpClientModal
                    visible={updatVisibleModal}
                    title={t('clientManagement.clientInfoManagementName')}
                    handleCancel={handleCancelSignUpModal}
                    initClientInfo={clientInfo}
                    id={id}
                />
            )}
            {showTerminationModal && (
                <ConfirmModal
                    visible={showTerminationModal}
                    title={
                        clientInfo.terminated
                            ? t('clientManagement.clientInfoManagement.confirmAcivityTitle')
                            : t('clientManagement.clientInfoManagement.confirmStopTitle')
                    }
                    content={
                        clientInfo.terminated
                            ? t('clientManagement.clientInfoManagement.warningMsg.canceltTerminationInfo')
                            : t('clientManagement.clientInfoManagement.warningMsg.terminationInfo')
                    }
                    contentTips={t('clientManagement.clientInfoManagement.warningMsg.terminationTips')}
                    onSubmit={terminateClientSubmit}
                    onCancel={() => setShowTerminationModal(false)}
                >
                    <div style={{ marginBottom: '1rem' }}>
                        <Select
                            itemKey="value"
                            width={460}
                            inputProps={{ value: selectValue }}
                            dataList={allClientsList}
                            handleChangeSelect={handleChangeSelect}
                            selectedValue={clientIdToConfirm}
                        />
                        {showMissmatchError && (
                            <span className={styles.form_error}>
                                {t('clientManagement.clientInfoManagement.warningMsg.companyNotMatch')}
                            </span>
                        )}
                    </div>
                </ConfirmModal>
            )}
            {clientInfoLoading && <LoadingMask />}
        </div>
    )
}

ClientInfoManagement.propTypes = {
    id: PropTypes.number.isRequired,
    updateClient: PropTypes.func.isRequired
}

export default ClientInfoManagement
